import React from 'react';
import Grid from '../components/Core/Grid';
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';

export default function BoletoLogGridViewer(props: any) {
    const boletoId = props.data?.id;

    const initialFilter = boletoId
        ? [{ name: 'boleto_id', value: String(boletoId), type: 'number', operator: '=' }]
        : [];

    return (
        <>
            <WindowBody noPadding>
                <Grid
                    router="boletolog"
                    initialFilter={initialFilter}
                />
            </WindowBody>
            <WindowFooter>
                <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
            </WindowFooter>
        </>
    );
}
